import { Building2 } from 'lucide-react'
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper'
import Button from 'Pages/LoginPage/Button'
import React from 'react'

const IdleTimeoutPopup = ({ onCancel, onYes }) => {
    return (
        <AuthWrapper heading="Good bye!" subheading="You have been logged out due to inactivity.">
            <div className="max-w-md mx-auto mt-10">
                <div className="space-y-6">
                    <Button loading={false} onClick={onYes} variant="primary" fullWidth>
                        Back to Login
                    </Button>
                </div>
            </div>
            {/* Trucare section with icon */}
            <div className="pt-6 mt-8 border-t border-gray-100">
                <div className="flex flex-col items-center text-sm">
                    <div className="flex items-center mb-2 space-x-2 text-gray-600">
                        <Building2 className="w-5 h-5" />
                        <span>Trucare Provider Management</span>
                    </div>
                    <a href="https://credapp.gettrucare.com/" target="_blank" rel="noopener noreferrer" className="font-semibold text-primary hover:text-primary">
                        Access your portal →
                    </a>
                </div>
            </div>

        </AuthWrapper>

    )
}

export default IdleTimeoutPopup
